import { MenuItem } from "./menu-item";

const REPORTS_MENU_ITEM: MenuItem = {
    label: "Reports",
    icon: "fa fa-file-text-o",
    route: "/admin/reports"
};

export const USER_MENU_ITEMS: MenuItem[] = [
    {
        id: "dashboard",
        label: "Dashboard",
        icon: "fa fa-dashboard",
        route: "/account/dashboard",
        data: {
            roles: ["Administrator"]
        }
    },
    {
        id: "records",
        label: "Request Records",
        icon: "fa fa-file-code-o",
        route: "/records",
        data: {
            roles: ["Administrator", "User"]
        }
    },
    {
        id: "my-intake",
        label: "My Intake",
        icon: "fa fa-download",
        route: "/intake",
        data: {
            roles: ["Administrator", "User"]
        }
    },
    {
        id: "release",
        label: "Release",
        icon: "fa fa-upload",
        route: "/release",
        data: {
            roles: ["Administrator", "User"]
        }
    },
    {
        id: "find-provider",
        label: "Find Provider",
        icon: "fa fa-search",
        data: {
            roles: ["Administrator", "User"]
        }
    },
    {
        id: "get-signatures",
        label: "Get Signatures",
        icon: "fa fa-pencil",
        route: "/signatures",
        data: {
            roles: ["Administrator", "User"]
        }
    }
];

export const SYSADMIN_REPORTING_MENU_ITEMS: MenuItem[] = [REPORTS_MENU_ITEM];

export const SYSADMIN_MENU_ITEMS: MenuItem[] = [
    {
        id: "admin-activity-diagnostics",
        label: "Activity / Diagnostics",
        icon: "fa fa-stethoscope",
        items: [
            {
                label: "Messages",
                icon: "fa fa-envelope",
                route: "/admin/messages"
            },
            {
                label: "Message Utils",
                icon: "fa fa-wrench",
                route: "/admin/utils"
            },
            {
                label: "Bulk Workflow Retry",
                icon: "fa fa-recycle",
                route: "/admin/workflows"
            },
            {
                label: "Secure Logs",
                icon: "fa fa-lock",
                route: "/admin/securelogs"
            },
            REPORTS_MENU_ITEM,
            {
                label: "Api Capture",
                icon: "fa fa-camera",
                route: "/admin/apicapture"
            }
        ]
    },
    {
        id: "admin-system",
        label: "System",
        icon: "fa fa-cogs",
        items: [
            {
                label: "TOS",
                icon: "fa fa-gavel",
                route: "/admin/eulas"
            },
            {
                label: "Subscription Plans",
                icon: "fa fa-dollar",
                route: "/admin/subscriptionplans"
            },
            {
                label: "Reserved Words",
                icon: "fa fa-flag",
                route: "/admin/reservedwords"
            },
            {
                label: "Health Service Areas",
                icon: "fa fa-users",
                route: "/admin/healthserviceareas"
            },
            {
                label: "Health Referral Regions",
                icon: "fa fa-building-o",
                route: "/admin/healthreferralregions"
            },
            {
                label: "Feature Toggle",
                icon: "fa fa-unlock",
                route: "/admin/featureToggle"
            },
            {
                label: "Downloads",
                icon: "fa fa-download",
                route: "/admin/downloads"
            },
            {
                label: "Service Accounts",
                icon: "fa fa-user",
                route: "/admin/serviceaccounts"
            },
            {
                label: "Client Applications",
                icon: "fa fa-share-alt",
                route: "/admin/clientapplications"
            },
            {
                label: "Audit Logs",
                icon: "fa fa-calculator",
                route: "/admin/audits"
            },
            {
                label: "Certificates",
                icon: "fa fa-certificate",
                route: "/admin/certificates"
            },
            {
                label: "Batch Imports",
                icon: "fa fa-object-group",
                route: "/admin/batchimports"
            }
        ]
    },
    {
        id: "admin-defaults",
        label: "Defaults",
        icon: "fa fa-compass",
        items: [
            {
                label: "Document Types",
                icon: "fa fa-file-text",
                route: "/admin/documenttypes"
            },
            {
                label: "Release Types",
                icon: "fa fa-tag",
                route: "/admin/releasetypes"
            }
        ]
    },
    {
        id: "admin-directory",
        label: "Directory",
        icon: "fa fa-folder-open",
        items: [
            {
                label: "Directory Downloads",
                icon: "fa fa-cloud-download",
                route: "/admin/directorydownloads"
            },
            {
                label: "Message Routing Rules",
                icon: "fa fa-exchange",
                route: "/admin/messageroutingrules"
            },
            {
                label: "Directory",
                icon: "fa fa-folder",
                route: "/admin/directory"
            }
        ]
    },
    {
        id: "admin-document-sources",
        label: "Document Sources",
        icon: "fa fa-book",
        items: [
            {
                label: "Direct Addresses",
                icon: "fa fa-at",
                route: "/admin/documentsources"
            },
            {
                label: "Fax Numbers",
                icon: "fa fa-fax",
                route: "/admin/fax"
            }
        ]
    },
    {
        id: "admin-connectors",
        label: "Connectors",
        icon: "fa fa-plug",
        items: [
            {
                label: "Connector Types",
                icon: "fa fa-usb",
                route: "/admin/connectors"
            },
            {
                label: "License Types",
                icon: "fa fa-certificate",
                route: "/admin/licensetypes"
            },
            {
                label: "License Keys",
                icon: "fa fa-key",
                route: "/admin/licensekeys"
            },
            {
                label: "Integrations",
                icon: "fa fa-plug",
                route: "/admin/integrations"
            },
            {
                label: "Integration Whitelist",
                icon: "fa fa-list",
                route: "/admin/integrations/whitelist"
            }
        ]
    },
    {
        id: "admin-partners",
        label: "Partners",
        icon: "fa fa-handshake-o",
        items: [
            {
                label: "Resellers",
                icon: "fa fa-male",
                route: "/admin/resellers"
            },
            {
                label: "Partners",
                icon: "fa fa-star",
                route: "/admin/partners"
            }
        ]
    },
    {
        id: "admin-customers",
        label: "Customers",
        icon: "fa fa-users",
        items: [
            {
                label: "Brands",
                icon: "fa fa-tags",
                route: "/admin/brands"
            },
            {
                label: "Networks",
                icon: "fa fa-sitemap",
                route: "/admin/networks"
            },
            {
                label: "Organizations",
                icon: "fa fa-globe",
                route: "/admin/organizations"
            },
            {
                label: "Users",
                icon: "fa fa-user",
                route: "/admin/users"
            },
            // {
            //     label: "Deprovision Users",
            //     icon: "fa fa-user-times",
            //     route: "/admin/users/deprovision"
            // },
            {
                label: "Organization Types",
                icon: "fa fa-building-o",
                route: "/admin/organizationTypes"
            },
            {
                label: "Organization Specialties",
                icon: "fa fa-building",
                route: "/admin/organizationSpecialties"
            }
        ]
    }
];
